import React from 'react';
import { Hourglass } from 'react-loader-spinner';
import { useLoadingStore } from '../../store/loadingStore'; // Import Zustand store

const HourglassLoader = () => {
  const { isLoading } = useLoadingStore(); // Access the loading state from Zustand store

  if (!isLoading) return null; // If not loading, don't render the spinner wrapper at all

  return (
    <div
      style={{
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        background: 'rgba(0, 0, 0, 0.5)', // Optional: semi-transparent background to dim the rest of the page
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999, // Ensure the spinner is on top of other content
      }}
    >
      {/* Hourglass Spinner */}
      <Hourglass
        visible={isLoading} // Spinner visibility is controlled by isLoading
        height="80" // Height of the spinner
        width="80" // Width of the spinner
        ariaLabel="hourglass-loading" // Accessibility label
        wrapperStyle={{}} // Custom styles for the wrapper
        wrapperClass="hourglass-loader" // Custom CSS class for the wrapper
        colors={['#F43C00', '#fca29d']} // Custom colors for the hourglass
      />
    </div>
  );
};

export default HourglassLoader;
